import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import InsertChartIcon from '@mui/icons-material/InsertChart';
import CardBody from "../../components/common/CardBody";
import DoughnutChart from "../manage/charts/DoughnutChart";
import ProgressCircle from "../manage/charts/ProgresCircle";
import BarChart from "../manage/charts/BarChart";
import GroupedBarChart from "../manage/charts/GroupedBarChart";
import AreaChart from "../manage/charts/AreaChart";
import ReactSpinner from "react-bootstrap/Spinner";
import { searchService } from "../../service/question/searchService";

const QuestionStatModal = ({ open, onClose, selectedLanguage, selectedGrade, selectedSubject, selectedCreator, selectedStartDate, selectedEndDate}) => {
    const [dashboardData, setDashboardData] = useState([]);
    const [dashboardDataLoading, setDashboardDataLoading] = useState(false);
    const [suitableArray, setSuitableArray] = useState([]);

    const getDashboardStats = async () => {
        setDashboardDataLoading(true);
        try {
            const res = await searchService.getAllQuestionStats(
                100,
                sessionStorage.getItem("manage_user_id"),
                sessionStorage.getItem("table_log_id"),
                sessionStorage.getItem("userType"),
                selectedLanguage,
                selectedGrade,
                selectedSubject,
                selectedCreator,
                selectedStartDate,
                selectedEndDate
            );
            setDashboardData(res.data);
            setSuitableArray(buildStatChartArray(res.data));
        } catch (error) {
            console.error(error);
        } finally {
            setDashboardDataLoading(false);
        }
    };

    const buildStatChartArray = (dashboardData) => {
        const groupedData = dashboardData.reduce((acc, obj) => {
            const key = `${obj.chart_type}_${obj.chart_id}`;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
        }, {});

        const arrays = Object.values(groupedData);
        const objectArray = arrays.map(arr => {
            const highestDisplayOrderObject = arr.reduce((maxObj, obj) => {
                if (!maxObj || obj.display_order > maxObj.display_order) {
                    return obj;
                } else {
                    return maxObj;
                }
            }, null);
            return {
                array: arr,
                chart_title: arr[0].chart_title,
                chart_type: arr[0].chart_type,
                chart_id: arr[0].chart_id,
                display_order: highestDisplayOrderObject.display_order
            };
        });

        objectArray.sort((a, b) => a.display_order - b.display_order);
        return objectArray;
    };

    useEffect(() => {
        if (open) {
            getDashboardStats();
        }
    }, [open]);

    const renderStatsCharts = () => {
        const renderOuterComponent = (Component, val_) => {
            return (
                <div
                    className="row d-flex justify-content-around chart-container w-100"
                    style={{ marginBottom: "20px" }}
                >
                    <div className="col-lg-12 col-md-12 d-flex justify-content-center pb-md-3 pb-sm-3">
                        <Component val={val_} />
                    </div>
                </div>
            );
        };

        return suitableArray?.map((val, index) => {
            let applyValues = val.array;
            if (val.chart_type === "Statistics-progress_circle") {
                applyValues = applyValues[0];
            }
            switch (val.chart_type) {
                case "Statistics-bar":
                    return renderOuterComponent(BarChart, applyValues);
                case "Statistics-progress_circle":
                    return renderOuterComponent(ProgressCircle, applyValues);
                case "Statistics-donut":
                    return renderOuterComponent(DoughnutChart, applyValues);
                case "Statistics-multibar":
                    return renderOuterComponent(GroupedBarChart, applyValues);
                case "Statistics-Multiline":
                    return renderOuterComponent(AreaChart, applyValues);
                default:
                    return null;
            }
        });
    };

    return (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={open}
            onHide={onClose}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                <div className="pl-3">
                                <p className="">
                                    <InsertChartIcon sx={{ fontSize: 28, color: "#815da8" }} /> Statistics
                                </p>
                            </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {dashboardDataLoading ? (
                    <ReactSpinner
                        animation="border"
                        role="status"
                        style={{ display: "block", margin: "auto" }}
                    >
                        <span className="sr-only">Loading...</span>
                    </ReactSpinner>
                ) : (
                    <div className="col-md-12">
                        <div className="announcement-container">
                           
                            <CardBody>
                                {renderStatsCharts()}
                            </CardBody>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    id="modal-close-button"
                    onClick={onClose}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default QuestionStatModal;